export default __webpack_public_path__ + "static/media/banner-4.9deb2e3a.jpg";